/** Seed data for the API Explorer's Create Order form: a worked example of the published create-order
 *  request, kept here rather than assembled in the component. */

import { OrderFileField } from "../../../utils/orderFiles.util";

/** Tokens marking the values a caller must replace before the body is a real order. */
export const PLACEHOLDER = {
  sku: "{sku}",
  coverUrl: "{cover_url}",
  dustJacketUrl: "{dust_jacket_url}",
  gutsUrl: "{guts_url}",
} as const;

/** How each order file is presented as a form input. Its placeholder is that file's token above. */
export const ORDER_FILE_INPUTS: Record<OrderFileField, { label: string; testId: string }> = {
  coverUrl: { label: "Cover PDF", testId: "cover-pdf-url" },
  dustJacketUrl: { label: "Dust Jacket PDF", testId: "dust-jacket-pdf-url" },
  gutsUrl: { label: "Pages PDF", testId: "pages-pdf-url" },
};

/** A realistic, ready-to-edit Create Order body. Placeholder tokens ({sku}, {cover_url}, …) mark the
 *  values a caller must replace; the product/asset fields are filled in from the selected product. */
export const createOrderExampleBody = {
  payload: "{custom_payload}",
  currency: "USD",
  shippingClassification: "standard",
  webhookUrl:
    "https://notification-testing-service.builder.blurb.com/notification/rpi-open-api-test/http-code-200/dummy",
  destination: {
    name: "John Doe",
    company: "RPI print",
    address1: "3325 S 116th St",
    city: "Tukwila",
    state: "Washington",
    postal: "98168",
    country: "US",
    phone: "(206) 905 5999",
    email: "shipping.dept@rpiprint.com",
  },
  orderItems: [
    {
      sku: PLACEHOLDER.sku,
      quantity: 1,
      retailPrice: "12.3",
      itemDescription: "{item_description}",
      product: {
        coverUrl: PLACEHOLDER.coverUrl,
        gutsUrl: PLACEHOLDER.gutsUrl,
      },
    },
  ],
} as const;

/** The two endpoints the Explorer exposes, mirroring the spec's order paths. Descriptions are UI
 *  copy; the request body for Create Order comes from {@link createOrderExampleBody}. */
export const API_EXPLORER_ENDPOINTS = {
  getOrder: { path: "/orders/:customerOrderId", description: "Get order by id" },
  createOrder: { path: "/orders/create", description: "Create an order" },
} as const;
